import '@sweep-io/sweep-design/dist/colors/sweepColors.css';
import './App.css';
import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router';
import { useAuthenticateUser } from '../hooks/useAuthenticateUser';
import LoadingSweep from './common/LoadingSweep';
import { Notifications } from './notifications/Notifications';
import { PersistentNotificationsProvider } from './notifications/PersistentNotificationsContext';
import ErrorBoundary from '../ErrorBoundary';
import { useRemoveAuthOrgQueryParamFromUrl } from '../hooks/useRemoveAuthOrgQueryParamFromUrl';

const GeneralError = lazy(() =>
  import('./pages/GeneralError').then((m) => ({ default: m.GeneralError })),
);
const VerificationNeeded = lazy(() => import('./pages/onboarding/VerificationNeeded'));
const PersonalEmailBlock = lazy(() => import('./pages/onboarding/PersonalEmailBlock'));
const AccountSelectionPage = lazy(() =>
  import('./account-selection/AccountSelectionPage').then((m) => ({
    default: m.AccountSelectionPage,
  })),
);

const AuthenticatedApp = () => {
  useRemoveAuthOrgQueryParamFromUrl();
  // Here goes logic that is relevant to all routes (including "*Auth2Redirect")
  return <Outlet />;
};

export const AppAuthGate = () => {
  const { userInfo, error, isPersonalEmail, notVerifiedAuthUserDetails, isNoAccountSetError } =
    useAuthenticateUser();
  const { isVerificationNeeded, authUserId, authUserEmail } = notVerifiedAuthUserDetails;
  const renderError = !!error;

  return (
    <ErrorBoundary>
      <div data-testid="sweep-app" style={{ height: '100%' }}>
        <PersistentNotificationsProvider>
          <Notifications />
          {userInfo ? (
            <AuthenticatedApp />
          ) : (
            <Suspense fallback={<LoadingSweep />}>
              {isPersonalEmail ? (
                <PersonalEmailBlock />
              ) : isVerificationNeeded ? (
                <VerificationNeeded authUserId={authUserId} authUserEmail={authUserEmail} />
              ) : isNoAccountSetError ? (
                <AccountSelectionPage />
              ) : renderError ? (
                <GeneralError />
              ) : (
                <LoadingSweep />
              )}
            </Suspense>
          )}
        </PersistentNotificationsProvider>
      </div>
    </ErrorBoundary>
  );
};
